import { get } from '@navent-jobs/config'
import loggerService from './logger-service'

export interface DatosEmpresaDto {
  denominacion: string
  razonSocial: string
  descripcion: string
  logoURL: string
  cuit: string
  pais: {
    id: number
    nombre: string
    isoCode: string
  }
  provincia: {
    id: number
    nombre: string
  }
  ciudad: string
  calle: string
  numero: string
  piso: string
  departamento: string
  codigoPostal: string
  industria: {
    id: number
    nombre: string
  }
  email: string
  webURL: string | null
  cantidadEmpleados: number
  condicionIVA: {
    nombre: string
    claseImpuesto: string
    habilitado: boolean
    tipoNif: string
    codigoTipoNif: string
    id: number
  }
  consultora: boolean
  clienteCRMId: number
  idUsuarioBumeranVendedor: number | null
  idClienteSap: string
  inclusiva: boolean
  id: number
}

interface DatosUsuarioEmpresaDto {
  mailEmpresa: string
  idUsuario: number
  tipoUsuario: string
  nombreUsuario: string
  apellidoUsuario: string
  numeroCliente: number
  mensajesTotalNoLeidos: number
  urlResumenCuenta: string
  limitePublicaciones: number
}

interface DenominacionesEmpresaDto {
  id: number
  nombre: string
  urlLogo: string
}

export interface FeaturesHabilitadasDto {
  idEmpresa: number
  hunterHabilitado: boolean
}

export class EmpresasDataService {
  public async getDatosEmpresaLogeada(): Promise<DatosEmpresaDto | null> {
    try {
      return await get('/api-company/empresas/empresas/me')
    } catch (error) {
      loggerService.logError(error.message, error.stack)
    }
    return null
  }

  public async getDatosUsario(): Promise<DatosUsuarioEmpresaDto | null> {
    try {
      return await get('/api-company/empresas/empresas/datosUsuario')
    } catch (error) {
      loggerService.logError(error.message, error.stack)
    }
    return null
  }

  public async getDenominacionesEmpresa(): Promise<DenominacionesEmpresaDto[]> {
    try {
      return await get('/api-company/empresas/empresas/denominaciones')
    } catch (error) {
      loggerService.logError(error.message, error.stack)
    }
    return []
  }

  public async getFeaturesHabilitadas(): Promise<FeaturesHabilitadasDto> {
    return await get<FeaturesHabilitadasDto>('/empresas/featuresHabilitadas')
  }
}

export default new EmpresasDataService()
